import React from 'react';
import PropTypes from 'prop-types';

import { getPageOnHostByID } from 'lib/api';
import { requireQueryByName } from 'lib/dependencies';

import RichText from 'components/Core/RichText';

const LegalPage = ({ page: { title, body } }) => {
  return (
    <>
      <div className="w-10/12 md:8/12 lg:w-7/12 container mx-auto py-4 md:py-8">
        <div className="u-block-margins">
          <h3 className="pb-4 md:pb-8">{title}</h3>
          {(body || []).map((paragraph) => (
            <RichText key={`paragraph-${paragraph.id}`} content={paragraph.value} />
          ))}
        </div>
      </div>
    </>
  );
};

LegalPage.getCustomInitialProps = async ({ id, contentType, hostname, previewData }) => {
  const query = requireQueryByName('LegalPage');
  const token = previewData ? previewData.token : '';
  const { page } = await getPageOnHostByID({
    id,
    contentType,
    query,
    token,
    hostname,
  });

  return {
    page,
  };
};

LegalPage.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    body: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
};

export default LegalPage;
